import { ERROR_ACTIONS } from './actions'
import { mapArrayElementsKeysToObjectKeys } from '../../helpers/utility'

export const INITIAL_STATE = {

}

const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action
  switch (type) {
    case ERROR_ACTIONS.ERROR_UPDATE:
      return {
        ...state,
        ...payload
      }
    case ERROR_ACTIONS.STATE_RESET:
      return {
        ...state,
        ...(mapArrayElementsKeysToObjectKeys(payload))
      }
    default:
      return {
        ...state
      }
  }
}
export default reducer
